import authSlice from "./auth";

export const auth = authSlice.reducer;
export const { checkUser, checkAuth } = authSlice.actions;
